import { FetchError } from "../errors/FetchError";
import {
  fetchApiImageAuth2,
  fetchApiImageAuth3,
  fetchFileWithAuthorization,
  fetchWithAuthorization,
} from "./fetch";
import moment from "moment";

/**
 * Normaliza una fecha a YYYY-MM-DD para el backend.
 *
 * Si llega un string en formato local (DD/MM/YYYY), moment sin formato
 * explicito lo interpreta como MM/DD/YYYY o lo da por invalido: una fecha
 * limite del 10/09 se guardaba como 9 de octubre, o no se guardaba. Se prueban
 * primero los formatos conocidos y recien despues el parseo libre, que sirve
 * para los Date y los ISO.
 */
const toBackendDate = (value) => {
  if (!value) return null;

  const parsed =
    typeof value === "string"
      ? moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true)
      : moment(value);

  if (!parsed.isValid()) {
    const loose = moment(value);
    return loose.isValid() ? loose.format("YYYY-MM-DD") : null;
  }

  return parsed.format("YYYY-MM-DD");
};

export const createDebtReceivable = async (datas) => {
  try {
    const data = await fetchWithAuthorization(
      "/condominium/debtstopay",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const updateDebtReceivable = async (id, datas) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/debtstopay/${id}`,
      datas,
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const DeleteDebtReceivable = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/debtstopay/${id}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const fetchDebtsReceivable = async (page, limit = 10, params) => {
  const { condominiumId, state, start_date, end_date } = params;

  let url = `/condominium/debtstopay/${condominiumId}?paymanted=${state}&page=${page}&limit=${limit}`;
  if (start_date && end_date) {
    url = url + `&start_date=${start_date}&end_date=${end_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchMovementsCondominium = async (
  page,
  limit = 10,
  condominiumId
) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/account/movements?condominium=${condominiumId}?page=${page}&limit=${limit}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchMovementsCondominiumReserveFunds = async (
  page,
  limit = 10,
  condominiumId
) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/account/movementsReserveFunds?condominium=${condominiumId}?page=${page}&limit=${limit}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

/* export const fetchDebtsToPayAsProperty = async (page, limit = 10, params) => {
  const { state, start_date, end_date } = params;

  try {
    let url = `/property/me/debtstopay?paymented=${state}&page=${page}&limit=${limit}`;

    if (start_date && end_date)
      url += `&start_date=${start_date}&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
}; */

export const fetchDebtsToPayAsPropertyCuenta = async (
  page,
  limit = 10,
  condominiumId
) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay?page=${page}&limit=${limit}&condominium_id=${condominiumId}&status=pending`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};
export const fetchDebtsToPayAsPropertyCuentaPending = async (
  page,
  limit = 10,
  params
) => {
  const { condominiumId, period_id, income_only, category } = params;


  if (!condominiumId) {
    // per_page devuelve el limit pedido, no un 10 fijo.
    //
    // Los hooks de paginacion adoptan el per_page de la respuesta como su
    // tamaño de pagina, y ese valor forma parte de la clave de SWR: un numero
    // distinto al pedido se pisa a si mismo, vuelve a pedir con el nuevo y se
    // queda ahi. En Cuentas por pagar del propietario el condominio llega async
    // (sale de su perfil), asi que este stub corria primero y bajaba el tamaño
    // de pagina de 500 a 10 de forma permanente: la lista que se manda a pagar
    // quedaba en 10 de 14 deudas.
    //
    // El equivalente del admin (fetchDebtsToPayAsPropertyOneAdmin) no tiene
    // stub porque recibe el condominio de la URL, y por eso esa pantalla nunca
    // tuvo el problema.
    return { data: [], meta: { current_page: 1, last_page: 1, total: 0, per_page: limit } };
  }

  let url = `/finances/debsToPay/pending?page=${page}&limit=${limit}&condominium_id=${condominiumId}`;

  url += income_only ? `&income_only=1` : `&status=pending`;

  if (period_id) {
    url += `&period_id=${period_id}`;
  }

  if (category) {
    url += `&category=${category}`;
  }
  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayAsPropertyPendingTotal = async (params) => {
  const { condominiumId, property_id } = params;

  let url = `/finances/debsToPay/pending/total?condominium_id=${condominiumId}&status=pending`;

  if (property_id) {
    url += `&property_id=${property_id}`;
  }
  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayAsPropertyCuentaPendingPeriod = async (
  page,
  limit = 10,
  params
) => {
  const { condominiumId, period_id, property_id, state = 0 } = params;
  const status = Number(state) === 1 ? "paymented" : "pending";

  // Este controlador resuelve el condominio desde "condominium", no "condominium_id".
  let url = `/finances/debsToPay/pending/period?page=${page}&limit=${limit}&condominium=${condominiumId}&status=${status}`;

  if (period_id) {
    url += `&period_id=${period_id}`;
  }
  if (property_id) {
    url += `&property_id=${property_id}`;
  }
  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayAsPropertyCuentaPendingPeriodTest = async (
  page,
  limit = 10,
  params
) => {
  const { condominiumId, period_id, property_id } = params;

  let url = `/finances/debsToPay/pending/period/test?page=${page}&limit=${limit}&condominium_id=${condominiumId}&status=pending`;

  if (period_id) {
    url += `&period_id=${period_id}`;
  }
  if (property_id) {
    url += `&property_id=${property_id}`;
  }
  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayAsPropertyCuentaPendingPeriodOne = async (
  params
) => {
  const { condominiumId, period_id } = params;

  const url = `/finances/debsToPay/pending/period/${period_id}&condominium_id=${condominiumId}&status=pending`;

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchPaymentQuote = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((item) => query.append(`${key}[]`, String(item)));
    } else {
      query.append(key, String(value));
    }
  });

  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay/payment/quote?${query.toString()}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "No se pudo calcular el monto del pago.");
  }
};

export const fetchDebtsToPayPendingCategories = async (params) => {
  const { condominiumId, property_id, period_id, payment_date } = params;

  // property_id solo lo necesita un manager, que cobra a nombre de otro. Para
  // un propietario el backend usa su propia propiedad activa, asi que exigirlo
  // aca devolvia null y su pantalla se quedaba sin los chips de categoria.
  if (!condominiumId || !period_id) {
    return null;
  }

  // El endpoint resuelve un unico periodo (Period::find), asi que con varios
  // seleccionados se manda el primero.
  const singlePeriodId = Array.isArray(period_id) ? period_id[0] : period_id;

  if (!singlePeriodId) {
    return null;
  }

  let url = `/finances/debsToPay/pending/categories?condominium_id=${condominiumId}&period_id=${singlePeriodId}`;

  if (property_id) {
    url += `&property_id=${property_id}`;
  }
  if (payment_date) {
    url += `&payment_date=${payment_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching debt category totals");
  }
};

export const fetchDebtsToPayAsPropertyCuentaPendingTotalPaid = async (
  paramPeriodTotal
) => {
  const { condominiumId, period_id, property_id } = paramPeriodTotal;

  let url = `/finances/debsToPay/totalPaid?condominium_id=${condominiumId}&status=pending`;

  if (period_id) {
    url += `&period_id=${period_id}`;
  }
  if (property_id) {
    url += `&property_id=${property_id}`;
  }
  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayAsPropertyOne = async (
  page,
  limit = 10,
  params
) => {
  const { condominiumId, debtsToPay } = params;

  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay/property?page=${page}&limit=${limit}&condominium_id=${condominiumId}&debtsToPay=${debtsToPay}&status=pending`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};
export const fetchDebtsToPayAsPropertyOneAdmin = async (
  page,
  limit = 10,
  params
) => {
  const { condominiumId, debtsToPay, period_id, income_only, category } = params;

  let url = `/finances/debsToPay/property/admin?page=${page}&limit=${limit}&condominium_id=${condominiumId}&debtsToPay=${debtsToPay}`;

  url += income_only ? `&income_only=1` : `&status=pending`;

  if (Array.isArray(period_id) && period_id.length > 0) {
    url += `&period_id=${period_id.join(",")}`;
  } else if (period_id) {
    url += `&period_id=${period_id}`;
  }

  if (category) {
    url += `&category=${category}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayAsProperty = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date } = params;

  let url = `/finances/debsToPay?condominium_id=${condominiumId}&status=pending&page=${page}&limit=${limit}`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayProperty = async (params) => {
  const { condominiumId } = params;
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay?condominium_id=${condominiumId}&status=pending`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtToPayAsPropertyDetails = async (date) => {
  try {
    const url = `/property/me/details?created_at=${date}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const findOneDebtReceivable = async (debtToPayId) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/debtstopay/show/${debtToPayId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const findOneDebtToPay = async (debtToPayId) => {
  try {
    const data = await fetchWithAuthorization(
      `/providerPayment/${debtToPayId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const DebtToPayDetails = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay?condominium_id=${condominiumId}&status=pending`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const DebtToPayProviderDetails = async (debtsToPay) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay/condominium/show/${debtsToPay}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const findOneDebtToPayAsProperty = async (debtToPayId) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/debtstopay/show/${debtToPayId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

/* export const findOneDebtToPayAsPropertyDetails = async (created_at) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/me/details?created_at=${created_at}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
}; */

export const findOneDebtToPayAsPropertyDetails = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay?condominium_id=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const findOneDebtToPayDetailsAsManager = async (
  created_at,
  condominiumId
) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/me/details?created_at=${created_at}&condominium=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPay = async (page, limit = 10, params) => {
  const { condominiumId, state, start_date, end_date } = params;

  // El filtro de la pantalla manda `state` (0 = No pagadas, 1 = Pagadas, 2 = Anuladas), pero
  // el backend espera `status`. Antes no se traducia y la url llevaba
  // "status=pending" fijo, asi que elegir "Pagadas" no cambiaba nada. Sin
  // `state` —AccountPlansList pide el listado sin filtro— se mantiene el
  // comportamiento anterior: solo las no pagadas.
  const status = Number(state) === 2 ? "voided" : Number(state) === 1 ? "paymented" : "pending";

  let url = `/finances/debsToPay/condominium?condominium_id=${condominiumId}&status=${status}&page=${page}&limit=${limit}`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayProviderTotal = async (
  page,
  limit = 10,
  params
) => {
  const { condominiumId, start_date, end_date, provider_id, paymented } =
    params;

  let url = `/finances/debsToPay/condominium/provider?condominium_id=${condominiumId}&page=${page}&limit=${limit}`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }
  if (paymented) url += `&paymented=${paymented}`;
  if (provider_id) {
    url += `&provider_id=${provider_id}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPayProviderTotalPending = async (params) => {
  const { condominiumId, start_date, end_date, provider_id, paymented } =
    params;

  let url = `/finances/debsToPay/condominium/provider/total?condominium_id=${condominiumId}`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  if (paymented) url += `&paymented=${paymented}`;

  if (provider_id) {
    url += `&provider_id=${provider_id}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebts = async (page, limit = 10, params) => {
  const { condominiumId } = params;

  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay/condominium?condominium_id=${condominiumId}&status=pending&page=${page}&limit=${limit}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchDebtsToPaid = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date } = params;

  let url = `/finances/debsToPay/condominium?condominium_id=${condominiumId}&status=paymented`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchFinances = async (params) => {
  const { condominiumId, start_date, end_date } = params;

  let url = `/finances/debsToPay/finance?condominium_id=${condominiumId}&status=pending`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const deletefinance = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/delete/${id}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to remove common areas failed");
  }
};

export const fetchDebtsToPayProvider = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date } = params;

  let url = `/finances/debsToPay?condominium_id=${condominiumId}&status=pending&page=${page}&limit=${limit}`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const createDebtToPay = async (datas) => {
  try {
    const data = await fetchApiImageAuth2("/providerPayment", datas, "POST");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear la cuenta por pagar"
    );
  }
};

export const addItemDebtToPay = async (paymentOrderId, datas) => {
  try {
    const data = await fetchApiImageAuth2(
      `/providerPayment/new/providerPayment/${paymentOrderId}`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar agregar la factura a la cuenta por pagar"
    );
  }
};

export const markAsPaidDebtToPay = async (paymentOrderId, datas) => {
  try {
    const data = await fetchApiImageAuth2(
      `/providerPayment/mark/as/paid/${paymentOrderId}`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar marcar como pagada la factura de la cuenta por pagar"
    );
  }
};
export const markAsPaidDebtToPayAsProperty = async (datas) => {
  try {
    const data = await fetchApiImageAuth2(
      "/property/payments/bill",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar marcar como pagada la factura de la cuenta por pagar"
    );
  }
};

export const markAsPaidDebtToPayAsPropertyAdmin = async (datas) => {
  try {
    const data = await fetchApiImageAuth2(
      "/property/payments/admin",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar marcar como pagada la factura de la cuenta por pagar"
    );
  }
};
export const markAsPaidDebtToPayAsPropertyAdminPass = async (datas) => {
  try {
    const data = await fetchApiImageAuth2(
      "/property/payments/admin/pass",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar marcar como pagada la factura de la cuenta por pagar"
    );
  }
};

export const createAliquot = async (datas) => {
  try {
    const data = await fetchWithAuthorization("/aliquot", datas, "POST");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear la alícuota"
    );
  }
};

export const updateAliquot = async (aliquotId, datas) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/${aliquotId}`,
      datas,
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar actualizar la alícuota"
    );
  }
};

export const deleteAliquot = async (aliquotId) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/${aliquotId}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear la alícuota"
    );
  }
};

export const fetchAliquots = async (page, limit = 10, params) => {
  const { condominiumId, state, start_date, end_date, search } = params;

  let url = `/aliquot?paymanted=${state}&page=${page}&limit=${limit}&condominium=${condominiumId}`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  const term = typeof search === "string" ? search.trim() : "";
  if (term) {
    url += `&search=${encodeURIComponent(term)}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchSpecialAliquotProfiles = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(`/aliquot/distribution-profile/condominium/${condominiumId}`);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching special aliquot profiles");
  }
};

export const createSpecialAliquotProfile = async (datas) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/distribution-profile`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error creating special aliquot profile");
  }
};

export const deleteSpecialAliquotProfile = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/distribution-profile/${id}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error deleting special aliquot profile");
  }
};

export const fetchSingleSpecialAliquotProfile = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(`/aliquot/distribution-profile/single/${condominiumId}`);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching single special aliquot profile");
  }
};

export const saveSingleSpecialAliquotProfile = async (datas) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/distribution-profile/single`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error saving special aliquot profile");
  }
};

/**
 * Baja el archivo con las alícuotas del condominio tal como están hoy: una
 * fila por unidad, con su usuario, su inmueble y su alícuota actual.
 *
 * Reemplaza a la plantilla vacía, que era una columna de números sin nada que
 * dijera a qué unidad pertenecía cada uno.
 */
export const exportAliquotsToExcel = async (condominiumId, format) => {
  try {
    const query = format ? `?format=${encodeURIComponent(format)}` : "";

    return await fetchFileWithAuthorization(
      `/aliquot/export/${condominiumId}${query}`
    );
  } catch (error) {
    throw new FetchError(error, "Error al exportar las alícuotas");
  }
};

export const importPropertiesAliquotFromExcel = async (condominiumId, file) => {
  try {
    const data = await fetchApiImageAuth3(
      `/aliquot/import/${condominiumId}`,
      file,
      "POST",
      true
    );

    return data;
  } catch (error) {
    throw new FetchError(error, "Error al importar propiedades desde Excel");
  }
};

/**
 * HO-HU-36: reparte la alícuota en partes iguales (100/N) entre todas las
 * unidades. Pisa las alícuotas personalizadas, así que quien llame tiene que
 * confirmarlo antes.
 */
export const distributeAliquotsEqually = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/distribute-equally/${condominiumId}`,
      {},
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al distribuir las alícuotas");
  }
};

export const importAdminPaymentsFromExcel = async (condominiumId, file) => {
  try {
    const data = await fetchApiImageAuth3(
      `/advance/payment/import/${condominiumId}`,
      file,
      "POST",
      true
    );

    return data;
  } catch (error) {
    throw new FetchError(error, "Error al importar saldos a favor desde Excel");
  }
};

export const importAccountsReceivableFromExcel = async (condominiumId, file) => {
  try {
    const data = await fetchApiImageAuth3(
      `/finances/import/${condominiumId}`,
      file,
      "POST",
      true
    );

    return data;
  } catch (error) {
    throw new FetchError(error, "Error al importar cuentas por cobrar desde Excel");
  }
};

export const fetchReports = async (condominiumId, params) => {
  const { period_id, exchange_rate_date, property_id } = params;

  let url = `/report/condominiumExpenseReport?condominium_id=${condominiumId}&period_id=${period_id}`;
  if (exchange_rate_date) {
    url += `&exchange_rate_date=${exchange_rate_date}`;
  }
  if (property_id) {
    url += `&property_id=${property_id}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchSingleFormReports = async (condominiumId, params) => {
  let periodId = null;
  if (typeof params === "object" && params !== null) {
    periodId = params.period_id;
  } else if (params) {
    periodId = params;
  }

  const propertyId =
    typeof params === "object" && params !== null ? params.property_id : null;
  const exchangeRateDate =
    typeof params === "object" && params !== null ? params.exchange_rate_date : null;

  let url = `/report/condominiumSingleFormReport?condominium_id=${condominiumId}`;
  if (periodId) {
    url += `&period_id=${periodId}`;
  }
  if (propertyId) {
    url += `&property_id=${propertyId}`;
  }
  if (exchangeRateDate) {
    url += `&exchange_rate_date=${exchangeRateDate}`;
  }

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchReportsProperty = async (condominiumId, params) => {
  const { period_id } = params;

  const url = `/report/reportPaidAccountsByProperty?condominium_id=${condominiumId}&period_id=${period_id}`;

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchIndicatorsReport = async (params = {}) => {
  const { condominium_id, start_date, end_date } = params;

  const queryParams = new URLSearchParams();
  if (condominium_id) queryParams.append("condominium_id", condominium_id);
  if (start_date) queryParams.append("start_date", start_date);
  if (end_date) queryParams.append("end_date", end_date);

  const queryString = queryParams.toString();
  const url = queryString ? `/report/indicators?${queryString}` : "/report/indicators";

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching indicators report");
  }
};

const buildIndicatorsMetricUrl = (path, page = 1, limit = 10, params = {}) => {
  const {
    condominium_id,
    search,
    start_date,
    end_date,
    has_records,
    stage,
  } = params;
  const queryParams = new URLSearchParams();

  const term = typeof search === "string" ? search.trim() : "";
  if (condominium_id) queryParams.append("condominium_id", condominium_id);
  if (term) queryParams.append("search", term);
  if (start_date) queryParams.append("start_date", start_date);
  if (end_date) queryParams.append("end_date", end_date);
  if (has_records) queryParams.append("has_records", has_records);
  if (stage) queryParams.append("stage", stage);
  if (limit) queryParams.append("limit", String(limit));
  if (page) queryParams.append("page", String(page));

  const queryString = queryParams.toString();
  return queryString ? `${path}?${queryString}` : path;
};

const fetchIndicatorsMetricByCondominium = async (path, page = 1, limit = 10, params = {}) => {
  const url = buildIndicatorsMetricUrl(path, page, limit, params);

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, `Error fetching indicators metric from ${path}`);
  }
};

export const fetchIndicatorsVisitors = async (page = 1, limit = 10, params = {}) =>
  fetchIndicatorsMetricByCondominium("/report/indicators/visitors", page, limit, params);

export const fetchIndicatorsReservations = async (page = 1, limit = 10, params = {}) =>
  fetchIndicatorsMetricByCondominium("/report/indicators/reservations", page, limit, params);

export const fetchIndicatorsDebtsToPay = async (page = 1, limit = 10, params = {}) =>
  fetchIndicatorsMetricByCondominium("/report/indicators/debtsToPay", page, limit, params);

export const fetchIndicatorsPropertyDebtsToPay = async (page = 1, limit = 10, params = {}) =>
  fetchIndicatorsMetricByCondominium("/report/indicators/propertyDebtsToPay", page, limit, params);

export const fetchIndicatorsPropertyPayments = async (page = 1, limit = 10, params = {}) =>
  fetchIndicatorsMetricByCondominium("/report/indicators/propertyPayments", page, limit, params);

/**
 * Embudo de adopción de root: condominios registrados, con carga inicial
 * completa, con planilla emitida, con propietarios activos y con pagos
 * reportados. Solo los pagos dependen del rango de fechas.
 */
export const fetchIndicatorsAdoption = async (params = {}) => {
  const url = buildIndicatorsMetricUrl("/report/indicators/adoption", null, null, params);

  try {
    return await fetchWithAuthorization(url);
  } catch (error) {
    throw new FetchError(error, "Error fetching adoption indicators");
  }
};

/**
 * Condominios del embudo de adopción. `stage` es la etapa
 * (onboarding | planilla | active_owners | payments) y `has_records` si se
 * quieren los que la cumplen (with) o los que no (without).
 */
export const fetchIndicatorsAdoptionCondominiums = async (page = 1, limit = 10, params = {}) =>
  fetchIndicatorsMetricByCondominium("/report/indicators/adoption/condominiums", page, limit, params);

/**
 * HO-TASK-247: la planilla de liquidación de una propiedad, con el mismo
 * contenido que el PDF que se manda por correo (la arma PlanillaNoticeData en
 * el backend). exchangeRate/exchangeRateDate son la tasa que el administrador
 * tiene puesta en el filtro del reporte.
 */
export const fetchPropertyPlanilla = async (propertyId, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.period_id) queryParams.append("period_id", String(params.period_id));
  if (params.exchange_rate) queryParams.append("exchange_rate", String(params.exchange_rate));
  if (params.exchange_rate_date) {
    queryParams.append("exchange_rate_date", String(params.exchange_rate_date));
  }

  const queryString = queryParams.toString();

  try {
    const data = await fetchWithAuthorization(
      `/report/planilla/${propertyId}${queryString ? `?${queryString}` : ""}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching the property planilla");
  }
};

export const fetchMyAliquotsAsProperty = async () => {
  try {
    const data = await fetchWithAuthorization("/aliquot");
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchOneAliquotByProperty = async (propertyId) => {
  try {
    const data = await fetchWithAuthorization(
      `/aliquot/property/${propertyId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar una alícuota."
    );
  }
};

export const fetchOneAliquot = async (aliquotId) => {
  try {
    const data = await fetchWithAuthorization(`/aliquot/${aliquotId}`);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar una alícuota."
    );
  }
};

export const findMyPaysAsProperty = async (page, limit = 10, params) => {
  try {
    const { condominiumId, status, start_date, end_date, property_id } = params;

    let url = `/property/payments/bill/all?page=${page}&limit=${limit}`;

    if (status) url += `&status=${status}`;
    if (condominiumId) url += `&condominium=${condominiumId}`;
    if (property_id) url += `&property_id=${property_id}`;
    if (start_date && end_date) {
      url += `&start_date=${start_date}&end_date=${end_date}`;
    }

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findMyPaysAsPropertyTotalPaid = async (
  condominiumId,
  period_id
) => {
  try {
    let url = `/property/payments/totalPaid`;

    if (condominiumId) url += `&condominium=${condominiumId}`;
    if (period_id) url += `&period_id=${period_id}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findMyPaysAsOneProperty = async (page, limit = 10, params) => {
  try {
    const { property_id, status, start_date, end_date } = params;

    let url = `/property/payments/bill/property/all?page=${page}&limit=${limit}`;

    if (status) url += `&status=${status}`;
    if (property_id) url += `&property_id=${property_id}`;
    if (start_date && end_date) {
      url += `&start_date=${start_date}&end_date=${end_date}`;
    }

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const fetchOneBillToPay = async (billToPay) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/payments/bill/${billToPay}`
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar una alícuota."
    );
  }
};

export const PaymentProperty = async (page, limit = 10, params) => {
  try {
    const { condominiumId, status, start_date, end_date, property_id } = params;
    let url = `/advance/payment?page=${page}&limit=${limit}`;

    if (status) url += `&status=${status}`;
    if (condominiumId) url += `&condominium=${condominiumId}`;
    if (property_id) url += `&property_id=${property_id}`;
    if (start_date && end_date) {
      url += `&start_date=${start_date}&end_date=${end_date}`;
    }

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const fetchPropertyPaymentOwners = async (page, limit = 10, params) => {
  try {
    const { condominiumId, search, start_date, end_date } = params;
    let url = `/property/payments/owners?page=${page}&limit=${limit}`;

    if (condominiumId) url += `&condominium=${condominiumId}`;
    const term = typeof search === "string" ? search.trim() : "";
    if (term) url += `&search=${encodeURIComponent(term)}`;
    if (start_date && end_date) {
      url += `&start_date=${start_date}&end_date=${end_date}`;
    }

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar los propietarios con pagos.");
  }
};

export const findMyPaysAsProvider = async (page, limit = 10, params) => {
  try {
    const { condominiumId, provider_id, start_date, end_date } = params;

    // La funcion recibia `page` y `limit` y no los mandaba. El endpoint pagina
    // igual, con los 15 por defecto de Laravel, asi que los botones de paginas
    // de las dos pantallas estaban puestos y no llevaban a ninguna parte:
    // siempre se veia la primera.
    let url = `/finances/debsToPay/condominium/payments?condominium_id=${condominiumId}&page=${page}&limit=${limit}`;

    if (provider_id) url += `&provider_id=${provider_id}`;

    // Las dos pantallas que llaman aca ya montaban el <Filter dateFilter> y
    // guardaban las fechas, pero este envio estaba comentado porque el
    // endpoint las ignoraba: se elegia un rango y salia todo igual. Ya filtra.
    //
    // Y van por separado, no las dos o ninguna: el filtro deja elegir solo la
    // de inicio, y con la condicion anterior esa sola no viajaba.
    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findMyPaysAsManager = async (page, limit = 10, params) => {
  try {
    const { condominiumCharge } = params;
    const url = `/charges/payment/${condominiumCharge}?page=${page}&limit=${limit}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findMyServicesAsManager = async (page, limit = 10, params) => {
  const { selectedCondominium, condominiumId } = params || {};
  const idToUse = selectedCondominium || condominiumId;
  try {
    let url = `/charges?page=${page}&limit=${limit}`;
    if (idToUse) url += `&condominium=${idToUse}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching services");
  }
};

export const findMyServicesAsManagerStatus = async (
  page = 1,
  limit = 10,
  params
) => {
  // en desuso
  try {
    const { selectedCondominium } = params;
    const data = await fetchWithAuthorization(
      `/charges?condominium=${selectedCondominium}&page=${page}&limit=${limit}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findMyServicesManager = async (datas, params) => {
  try {
    const { condominiumId } = params;
    const data = await fetchWithAuthorization(
      `/charges?condominium=${condominiumId}`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const getPropertyPayment = async (property) => {
  try {
    const url = `/property/payments/${property}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findOnePaymentAsProperty = async (propertyPayment) => {
  try {
    const url = `/property/payments/${propertyPayment}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const findOnePaymentProperty = async (propertyPayment) => {
  try {
    const url = `/advance/payment/${propertyPayment}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

/* export const changeStatusPayment = async (propertyPayment, obj) => {
  try {
    const url = `/property/payments/${propertyPayment}`;
    const data = await fetchWithAuthorization(url, obj, "PUT");
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
}; */

export const changeStatusPayment = async (propertyPaymentBill, obj) => {
  try {
    const url = `/property/payments/${propertyPaymentBill}`;
    const data = await fetchWithAuthorization(url, obj, "PUT");
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

const VOID_PATHS = {
  bill: (id) => `/property/payments/bill/${id}`,
  advance: (id) => `/advance/payment/${id}`,
  provider: (id) => `/finances/debsToPay/payment/${id}`,
  debt: (id) => `/finances/debsToPay/condominium/${id}`,
};

export const fetchVoidPreview = async (kind, id) => {
  try {
    const data = await fetchWithAuthorization(`${VOID_PATHS[kind](id)}/void-preview`);
    return data;
  } catch (error) {
    throw new FetchError(error, "No se pudo revisar qué revierte la anulación.");
  }
};

export const voidPayment = async (kind, id, reason) => {
  try {
    const data = await fetchWithAuthorization(`${VOID_PATHS[kind](id)}/void`, { reason }, "POST");
    return data;
  } catch (error) {
    throw new FetchError(error, "No se pudo anular el pago.");
  }
};

export const changeStatusPaymentProperty = async (propertyPayment, obj) => {
  try {
    const url = `/advance/payment/${propertyPayment}`;
    const data = await fetchWithAuthorization(url, obj, "PUT");
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const GetMyBalance = async () => {
  try {
    const url = "/property/show/balance/me";
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar tu balance."
    );
  }
};

// La caja de una propiedad concreta. GetMyBalance solo sirve al propietario
// logueado; el administrador que le cobra necesita ver la del dueño.
export const GetPropertyBalance = async (propertyId) => {
  try {
    const url = `/property/show/balance/${propertyId}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar el saldo del propietario."
    );
  }
};

export const GetMovementsProperty = async (page, limit = 10, param) => {
  try {
    const { start_date, end_date } = param;
    let url = `/property/movementsProperty?page=${page}&limit=${limit}`;
    if (start_date && end_date)
      url += `&start_date=${start_date}&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar tu balance."
    );
  }
};

export const GetBalanceCondominium = async (params) => {
  try {
    const { condominiumId } = params;

    const url = `/finances/debtsToPay/condominium?condominium_id=${condominiumId}/total`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar tu balance."
    );
  }
};

export const createAdvancePayment = async (datas) => {
  try {
    const data = await fetchApiImageAuth2("/advance/payment", datas, "POST");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al registrar el saldo a favor."
    );
  }
};

export const createAdvanceAdminPayment = async (datas, propertyId) => {
  try {
    const data = await fetchApiImageAuth2(
      `/advance/payment/admin/${propertyId}`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al registrar el saldo a favor."
    );
  }
};

export const createAdvancePaymentAdmin = async (datas) => {
  try {
    const data = await fetchApiImageAuth2(
      "/condominium/account/balance",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al registrar el saldo a favor."
    );
  }
};

export const changeAdvanceStatus = async (advancePayment, datas) => {
  try {
    const url = `/advance/payment/${advancePayment}`;
    const data = await fetchWithAuthorization(url, datas, "PUT");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar los saldos a favor."
    );
  }
};

export const findAllAdvancePayments = async (
  page = 1,
  limit = 5,
  { status, condominiumId }
) => {
  try {
    let url = `/advance/payment?condominium=${condominiumId}&page=${page}&limit=${limit}`;
    if (status) {
      url += `&status=${status}`;
    }
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar los saldos a favor."
    );
  }
};

export const createManagerPayment = async (charge, obj) => {
  try {
    const data = await fetchApiImageAuth2(
      `/charges/payment/${charge}`,
      obj,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al crear un pago.");
  }
};

export const updateStatusManagerPayment = async (payment, status) => {
  try {
    const data = await fetchWithAuthorization(
      `/charges/payment/${payment}`,
      { status },
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al cambiar el estado del pago."
    );
  }
};

export const fetchCondominiumFunds = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds?condominium_id=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCondominiumCurrent = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/account/get?condominium=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCreatePeriod = async (condominiumId, datas) => {
  try {
    const data = await fetchWithAuthorization(
      "/periods",
      {
        condominium_id: condominiumId,
        ...datas,
        start_at: moment(datas.start_at).format("YYYY-MM-DD"),
        end_at: moment(datas.end_at).format("YYYY-MM-DD"),
        discount_percentage:
          datas.discount_percentage !== undefined &&
          datas.discount_percentage !== null &&
          datas.discount_percentage !== ""
            ? Number(datas.discount_percentage)
            : null,
        discount_due_date: toBackendDate(datas.discount_due_date),
      },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchUpdatePeriod = async (periodId, condominiumId, datas) => {
  try {
    const data = await fetchWithAuthorization(
      `/periods/${periodId}`,
      {
        condominium_id: condominiumId,
        ...datas,
        start_at: moment(datas.start_at).format("YYYY-MM-DD"),
        end_at: moment(datas.end_at).format("YYYY-MM-DD"),
        discount_percentage:
          datas.discount_percentage !== undefined &&
          datas.discount_percentage !== null &&
          datas.discount_percentage !== ""
            ? Number(datas.discount_percentage)
            : null,
        discount_due_date: toBackendDate(datas.discount_due_date),
      },
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const deletePeriod = async (periodId) => {
  try {
    return await fetchWithAuthorization(`/periods/${periodId}`, null, "DELETE");
  } catch (error) {
    throw new FetchError(error, "No se pudo eliminar el período.");
  }
};

export const fetchOnePeriod = async (periodId, condominiumId) => {
  try {
    const params = condominiumId ? { condominium_id: condominiumId } : {};
    const data = await fetchWithAuthorization(`/periods/${periodId}`, params, "GET");
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

const appendFormData = (formData, value, key) => {
  if (value === undefined || value === null) return;
  if (value instanceof File || value instanceof Blob) {
    formData.append(key, value);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item, index) => appendFormData(formData, item, `${key}[${index}]`));
    return;
  }
  if (typeof value === "object" && !(value instanceof Date)) {
    Object.entries(value).forEach(([childKey, childValue]) =>
      appendFormData(formData, childValue, key ? `${key}[${childKey}]` : childKey)
    );
    return;
  }
  formData.append(key, typeof value === "boolean" ? (value ? "1" : "0") : value);
};

const toFormData = (payload) => {
  const formData = new FormData();
  appendFormData(formData, payload, "");
  return formData;
};

export const fetchCreateCommonCost = async (condominiumId, datas) => {
  try {
    const payload = {
      condominium_id: Number(condominiumId),
      ...datas,
      type_id: datas.type_id,
    };
    const data = datas.paid
      ? await fetchApiImageAuth2("/finances", toFormData(payload), "POST")
      : await fetchWithAuthorization("/finances", payload, "POST");
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCreateIndividualCost = async (condominiumId, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const data = await fetchApiImageAuth3(
      `/finances/import/${condominiumId}`,
      file,
      "POST",
      true
    );

    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCommonCost = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date, type_id, active } = params;

  try {
    let url = `/finances?type_id=${type_id}&condominium_id=${condominiumId}&page=${page}&limit=${limit}`;

    if (start_date && end_date) {
      url += `&start_at=${start_date}&end_at=${end_date}`;
    }

    if (active !== undefined && active !== "") url += `&active=${active}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const executeJobs = async (condominiumId, periodId, autoPayWithCreditBalance, note) => {
  try {
    const body = {};
    if (autoPayWithCreditBalance !== undefined) {
      body.auto_pay_with_credit_balance = autoPayWithCreditBalance ? 1 : 0;
    }
    if (note !== undefined) {
      body.note = note;
    }
    const url = `/finances/debsToPay/jobs/${condominiumId}/${periodId}`;

    const data = await fetchWithAuthorization(url, body, "POST");
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchPlanillaSteps = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay/planillaSteps/${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const executeDebtsToPayJobs = async (condominiumId, periodId) => {
  try {
    const url = `/finances/debsToPay/jobs/condominiun/${condominiumId}/${periodId}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

/**
 * Cómo sale la planilla que se envía: con la tasa y la presentación que el
 * administrador tiene en pantalla al pulsar enviar.
 *
 * La tasa es la que vio él y no la del día en que la cola procese el correo;
 * si no se manda, el backend resuelve la última registrada.
 *
 * itemsInQuote es el interruptor de HO-TASK-246: va siempre, porque su valor
 * apagado también es una decisión del administrador y no la ausencia de una.
 */
const planillaNoticeQuery = (params = {}) => {
  const { exchangeRate, exchangeRateDate, itemsInQuote, totalsInQuote = true } = params;
  const query = new URLSearchParams();

  if (Number(exchangeRate) > 0) {
    query.append("exchange_rate", String(Number(exchangeRate)));

    if (exchangeRateDate) {
      query.append("exchange_rate_date", exchangeRateDate);
    }
  }

  query.append("items_in_quote", itemsInQuote ? "1" : "0");
  query.append("totals_in_quote", totalsInQuote ? "1" : "0");

  return `?${query.toString()}`;
};

export const sendEmail = async (condominiumId, periodId, params) => {
  try {
    const url = `/finances/debsToPay/sendEmail/${condominiumId}/${periodId}${planillaNoticeQuery(params)}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchAutoPaySummary = async (condominiumId, periodId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/debsToPay/autoPaySummary/${condominiumId}/${periodId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const sendEmailAdmin = async (condominiumId, periodId, userId, params) => {
  try {
    const url = `/finances/debsToPay/sendEmailAdmin/${condominiumId}/${periodId}/${userId}${planillaNoticeQuery(params)}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const CommonCostsDetails = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances?condominium_id=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCondominiumPeriodSelect = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/periods?condominium=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCondominiumPeriod = async (page, limit = 10, params) => {
  const { condominiumId, search } = params;
  try {
    let url = `/periods?page=${page}&limit=${limit}&condominium=${condominiumId}`;
    const term = typeof search === "string" ? search.trim() : "";
    if (term) url += `&search=${encodeURIComponent(term)}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchExpenses = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/types?condominium_id=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchCreateReserveFund = async (condominiumId, datas) => {
  try {
    const data = await fetchWithAuthorization(
      "/finances/reserveFunds",
      {
        condominium_id: Number(condominiumId),
        ...datas,
      },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear la alícuota"
    );
  }
};

export const fetchReserveFund = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date, active } = params;

  try {
    let url = `/finances/reserveFunds?condominium_id=${condominiumId}&page=${page}&limit=${limit}`;

    if (start_date && end_date) {
      url += `&start_at=${start_date}&end_at=${end_date}`;
    }

    if (active !== undefined && active !== "") {
      url += `&active=${active}`;
    }

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchReserve = async (condominiumId) => {
  /*   const {condominiumId} = params; */

  try {
    const url = `/finances/reserveFunds?condominium_id=${condominiumId}&is_cash=true`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const findOneReserve = async (reserve) => {
  try {
    const url = `/finances/reserveFunds/${reserve}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al consultar tus pagos.");
  }
};

export const fetchReserveFundDetails = async (params) => {
  const { reserveFundId, condominiumId } = params;

  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds/detail/property/${reserveFundId}?condominium_id=${condominiumId}`
    );

    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Property failed");
  }
};

export const updateReserveFunds = async (id, reserve) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds/update/${id}`,
      reserve,
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "No se puede emitir cobro si hay otro en proceso."
    );
  }
};

export const toggleReserveFundPaymentStatus = async (paymentId, isActive) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds/payments/toggle-status/${paymentId}`,
      { active: isActive },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to toggle reserve fund payment status failed");
  }
};

export const updateReserveFundPaymentAmount = async (paymentId, amount) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds/payments/${paymentId}`,
      { amount },
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to update reserve fund payment amount failed");
  }
};

export const fetchOrdinaryExpensesTotal = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds/ordinaryExpensesTotal/${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to fetch ordinary expenses total failed");
  }
};

export const activateAllReserveFundPayments = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/reserveFunds/payments/activate-all/${condominiumId}`,
      {},
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to activate all reserve fund payments failed");
  }
};

export const findOne = async (finance) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/show/${finance}`,
      "GET"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Find bank failed");
  }
};

export const update = async (id, common) => {
  try {
    const data = common?.paid
      ? await fetchApiImageAuth2(`/finances/${id}`, toFormData({ ...common, _method: "PUT" }), "POST")
      : await fetchWithAuthorization(`/finances/${id}`, common, "PUT");
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create bank failed");
  }
};

export const activateOrDeactivateFinances = async (
  condominiumId,
  { type_id = 1, active = 1 } = {}
) => {
  try {
    const params = new URLSearchParams({
      type_id: String(type_id),
      active: String(active),
    });
    const data = await fetchWithAuthorization(
      `/finances/activate/${condominiumId}?${params.toString()}`,
      "GET"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Http call to activate or deactivate finances failed"
    );
  }
};

export const fetchCurrentAccount = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/account/get?condominium=${condominiumId}&type="CURRENT"`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchCreateToPayProvider = async (condominiumId, datas) => {
  try {
    const data = await fetchApiImageAuth2(
      `/finances/debsToPay/payment?condominium_id=${condominiumId}`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const createIncome = async (datas) => {
  try {
    const data = await fetchApiImageAuth2("/finances/income", datas, "POST");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear el ingreso"
    );
  }
};

export const updateIncome = async (id, datas) => {
  try {
    const data = await fetchApiImageAuth2(`/finances/income/${id}`, datas, "POST");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar actualizar el ingreso"
    );
  }
};

export const deleteIncome = async (id) => {
  try {
    const data = await fetchWithAuthorization(`/finances/income/${id}`, null, "DELETE");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar eliminar el ingreso"
    );
  }
};

export const createPaymentFund = async (datas) => {
  try {
    const data = await fetchApiImageAuth2(
      "/finances/income/Fund",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear la alícuota"
    );
  }
};

export const addReserveFundBalance = async (reserveFundId, datas) => {
  try {
    const data = await fetchApiImageAuth2(
      `/finances/reserveFunds/${reserveFundId}/balance`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al agregar saldo al fondo de reserva"
    );
  }
};

// Traduce el filtro único de la UI (view) a los parámetros reales que entiende
// el backend: "active" (pendiente/emitido en planilla) y "destination".
const appendIncomeViewParams = (url, view) => {
  switch (view) {
    case "pending":
      return `${url}&active=1&destination=PLANILLA`;
    case "issued":
      return `${url}&active=0`;
    case "cash":
      return `${url}&destination=CASH`;
    case "reserve_fund":
      return `${url}&destination=RESERVE_FUND`;
    default:
      return url;
  }
};

export const fetchCommonIncome = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date, view } = params;

  let url = `/finances/income?condominium_id=${condominiumId}&is_common_type=1`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  url = appendIncomeViewParams(url, view);

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchIndividualIncome = async (page, limit = 10, params) => {
  const { condominiumId, start_date, end_date, view } = params;

  let url = `/finances/income?condominium_id=${condominiumId}&is_common_type=0`;

  if (start_date && end_date) {
    url += `&start_date=${start_date}&end_date=${end_date}`;
  }

  url = appendIncomeViewParams(url, view);

  try {
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchChartOfAccountsSummary = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/summary?condominium_id=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error");
  }
};

export const fetchJournal = async (condominiumId, startDate = null, endDate = null) => {
  try {
    let url = `/finances/accounting/journal?condominium_id=${condominiumId}`;
    if (startDate && endDate) {
      url += `&start_date=${startDate}&end_date=${endDate}`;
    }
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al obtener el libro diario");
  }
};

export const fetchLedgerGrouped = async (condominiumId, startDate = null, endDate = null) => {
  try {
    let url = `/finances/accounting/ledger?condominium_id=${condominiumId}`;
    if (startDate && endDate) {
      url += `&start_date=${startDate}&end_date=${endDate}`;
    }
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al obtener el libro mayor");
  }
};

// Código de subcuenta estable por propiedad y por proveedor, calculado en el
// backend (misma fuente que usan el Libro Diario y el Libro Mayor), para que el
// Plan de Cuentas no tenga que recalcularlo por su cuenta.
export const fetchAccountEntityCodes = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(`/finances/accounting/entity-codes?condominium_id=${condominiumId}`);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al obtener los códigos de cuenta");
  }
};

export const toggleIndividualStatus = async (costId, isActive) => {
  try {
    const data = await fetchWithAuthorization(
      `/finances/toggle-status/${costId}`,
      { active: isActive },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to toggle individual status failed");
  }
};

export const downloadExpenseImportTemplate = async (condominiumId, format = "xlsx") => {
  try {
    return await fetchFileWithAuthorization(
      `/finances/expense-import/${condominiumId}/template?format=${encodeURIComponent(format)}`
    );
  } catch (error) {
    throw new FetchError(error, "No se pudo descargar la plantilla de gastos.");
  }
};

export const previewExpenseImport = async (condominiumId, formData) => {
  try {
    return await fetchApiImageAuth3(`/finances/expense-import/${condominiumId}/preview`, formData, "POST");
  } catch (error) {
    throw new FetchError(error, "No se pudo revisar el archivo de gastos.");
  }
};

export const applyExpenseImport = async (condominiumId, formData) => {
  try {
    return await fetchApiImageAuth3(`/finances/expense-import/${condominiumId}`, formData, "POST");
  } catch (error) {
    throw new FetchError(error, "No se pudieron cargar los gastos.");
  }
};

export const fetchDebtToPayPayments = async (debtToPayId) => {
  try {
    return await fetchWithAuthorization(`/finances/debsToPay/condominium/show/payments/${debtToPayId}`);
  } catch (error) {
    throw new FetchError(error, "No se pudieron consultar los pagos de la cuenta por pagar.");
  }
};
